/*
 * @Author:
 * @LastEditTime: 2022-06-16 11:20:35
 * @Description:
 */
import qs from 'qs'
import To from 'await-to-js'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiCommonMixin = {
  async queryAttributes(arg = { method: '', params: {} }) {
    const [err, res] = await To(
      wizStandardInstance.get(`/api/std/StdClass?${qs.stringify(arg.params)}`)
    )
    return Callback.globalCB(err, res, { errorMsg: false })
  },
}

export default {
  methods: ApiCommonMixin,
}
